import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {BrMaskerModule} from 'br-mask';
import {InterceptService} from '../../../../../../../core/intercept/intercept.service';
import {HTTP_INTERCEPTORS} from '@angular/common/http';

import {ComponentsModule} from 'src/app/core/shared/modules/components.module';
import {PaymentLotPage} from './payment-lot.page';
import {UiBsTranslateModule} from '@wlp/ui-bs-translate';

@NgModule({
    imports: [
      CommonModule,
      IonicModule,
      ComponentsModule,
      RouterModule,
      BrMaskerModule,
      ReactiveFormsModule,
      UiBsTranslateModule,
    ],
  declarations: [
    PaymentLotPage,
  ],
  exports: [
    PaymentLotPage,
  ],
  providers: [
    InterceptService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptService,
      multi: true,
    },
  ],
  entryComponents: [],
  bootstrap: [],
})
export class PaymentLotModule { }
